import {
  del,
  get,
  patch,
  post,
  type RequestConfig,
} from "../shared/api-client";
import type {
  ApiItemResponse,
  ListQuery,
  PaginatedResult,
} from "@project/types/location";
import type { DairyProductUsage } from "@project/types/vrindavan-gaushala";
import {
  JIVANDHARA_BASE,
  SILENT_LIST,
  fetchListPage,
  unwrapItem,
} from "./list-api-helpers";

const BASE = `${JIVANDHARA_BASE}/dairy-product-usages`;
const SILENT: RequestConfig = { showNotification: false };

class DairyProductUsageService {
  listPage = (
    query: ListQuery = {}
  ): Promise<PaginatedResult<DairyProductUsage>> => {
    return fetchListPage<DairyProductUsage>(`${BASE}/`, query);
  };

  get = async (id: number): Promise<DairyProductUsage | undefined> => {
    const data = await get<ApiItemResponse<DairyProductUsage> | DairyProductUsage>(
      `${BASE}/${id}/`,
      SILENT_LIST
    );
    return unwrapItem(data);
  };

  create = async (
    payload: Record<string, unknown>
  ): Promise<DairyProductUsage | undefined> => {
    const data = await post<
      ApiItemResponse<DairyProductUsage> | DairyProductUsage,
      Record<string, unknown>
    >(`${BASE}/`, payload, SILENT);
    return unwrapItem(data);
  };

  update = async (
    id: number,
    payload: Record<string, unknown>
  ): Promise<DairyProductUsage | undefined> => {
    const data = await patch<
      ApiItemResponse<DairyProductUsage> | DairyProductUsage,
      Record<string, unknown>
    >(`${BASE}/${id}/`, payload, SILENT);
    return unwrapItem(data);
  };

  delete = async (id: number): Promise<void> => {
    await del(`${BASE}/${id}/`, SILENT);
  };
}

export const dairyProductUsageService = new DairyProductUsageService();
